import React, { useState, useEffect } from 'react';
import '../../Css/AjouterRoom.css'; // Import the CSS file

export default function AjouterRoom() {
  const [title, setTitle] = useState('');
  const [error, setError] = useState('');
  const [data, setData] = useState([]);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('token'); // Get token from localStorage
  const apiUrl = process.env.REACT_APP_API_URL;



  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (title === '') {
      setError('Le champ doit être rempli');
      return;
    }

    const url = editId
      ? `${apiUrl}/api/edit/rooms/${editId}`
      : `${apiUrl}/api/rooms`;

    try {
      const response = await fetch(url, {
        method: editId ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ title }),
      });

      if (!response.ok) {
        throw new Error('Failed to submit');
      }

      const newData = await response.json();
      if (editId) {
        // Update existing entry
        setData(data.map(item => (item.id === newData.id ? newData : item)));
      } else {
        // Add new entry
        setData([...data, newData]);
      }
      
      resetForm();
    } catch (error) {
      setError(`Failed to submit data: ${error.message}`);
    }
  };

  const handleEdit = (item) => {
    setTitle(item.title);
    setEditId(item.id);
  };

  const handleDelete = async (id) => {
    const confirmation = window.confirm("Are you sure you want to delete this item?");
  
    if (!confirmation) {
      return; // If user cancels, do nothing and return early.
    }
    
    const url = `${apiUrl}/api/delete/rooms/${id}`;
    try {
      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        throw new Error('Failed to delete');
      }
  
      // Remove deleted item from state
      setData(data.filter(item => item.id !== id));
    } catch (error) {
      console.error('Failed to delete data', error);
    }
  };

  
  const fetchData = async () => {
    try {
      const roomResponse = await fetch(`${apiUrl}/api/rooms`, {
        headers: {'Authorization': `Bearer ${token}`},
      });

      const rooms = await roomResponse.json();

      /*const combinedData = [
        ...rooms.map(item => ({ ...item, type: 'room' })),
        ...clients.map(item => ({ ...item, type: 'organisme' }))
      ];*/

      setData(rooms);
    } catch (error) {
      console.error('Failed to fetch data', error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setTitle('');
    setEditId(null);
    setError('');
  };

  const handleCancel = () => {
    resetForm(); // Reset the form and exit edit mode
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="AjouterRoom">
      {error && <p className="AjouterRoom__error-message">{error}</p>}
      <form onSubmit={handleSubmit} className="AjouterRoom__form">
        <div className="AjouterRoom__form-group">
          <label className="AjouterRoom__label" htmlFor="title">Saisissez le nom de la chambre</label>
          <input type="text" id="title" className="AjouterRoom__input" value={title} onChange={handleTitleChange} />
        </div>
        <button type="submit" className="AjouterRoom__submit-button">
        Enregistrer
        </button>
        {editId && (
          <button type="button" onClick={handleCancel} className="AjouterRoom__cancel-button">
            Annuler
          </button>
        )}
      </form>

      {loading ? <p>Loading...</p> : (

      <table className="AjouterRoom__data-table">
        <thead>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={`${item.id}-${item.title}`}>
              <td>{item.title}</td>
              <td className="AjouterRoom__button">
                <button onClick={() => handleEdit(item)} className="AjouterRoom__edit-button">Mettre à jour</button>
                <button onClick={() => handleDelete(item.id)} className="AjouterRoom__delete-button">Supprimer</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
    </div>
  );
}
